import React from 'react'
import { flowRight as compose } from 'lodash'
import { RouteChildrenProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  StockKeepingUnitDetail as Content,
  StockKeepingUnitService,
  initialStockKeepingDetail,
  renderBreadcrumbsDetail,
} from 'features/StockKeepingUnit'
import { Button } from 'components'
import { withBackOfficeCms } from 'helpers/hocs'
import { useBreadcrumbs } from 'helpers/hooks'
import { routes } from 'helpers/routes'

const StockKeepingUnitDetail = ({
  history,
  match,
}: RouteChildrenProps<{ id: string }>): JSX.Element => {
  const { t } = useTranslation(['layout', 'sku', 'common'])

  const base = 'con-stock-keeping-unit'
  const id = match?.params.id || ''

  const [{ data, loading }] = StockKeepingUnitService.useFindOneById(id)

  useBreadcrumbs(renderBreadcrumbsDetail(id))

  return (
    <div className={`${base}__container ${base}__container-detail`}>
      <Content data={data || initialStockKeepingDetail} loading={loading} />
      <div className={`${base}__con-detail-bottom`}>
        <Button
          className={`${base}__form-btn`}
          onClick={() => history.push(`${routes.product.path}/${id}/edit`)}
          variants='primary'
        >
          {t('common:edit.button')}
        </Button>
      </div>
    </div>
  )
}

export default compose(withBackOfficeCms)(StockKeepingUnitDetail)
